import { Group, Stack } from '@mantine/core';
import { fetchSwitchRegion, useSuspenseApiMemberEnv } from '@repo/api-codegen';
import { Icon, Text } from '@repo/foundations';
import { useCallback } from 'react';
import { queryClient } from '../../../../api';
import { memberEnvQueryKeyFactory } from '../../../../api/hooks/utils/constants';
import { useStyles } from './WorkspaceSelectorSubMenu.styles';

export function WorkspaceSelectorRegionSubMenu() {
	const { classes, theme } = useStyles();
	const { data } = useSuspenseApiMemberEnv({});

	const handleClick = useCallback(async (region: string) => {
		await fetchSwitchRegion({
			pathParams: { regionName: region },
		});
		queryClient.invalidateQueries({
			queryKey: memberEnvQueryKeyFactory.all(),
		});
		window.location.reload();
	}, []);

	return (
		<Stack className={classes.workspacesListSectionWrapper}>
			{data?.REGION_OPTIONS?.split(',')?.map((region) => (
				<Group
					onClick={() => handleClick(region)}
					key={region}
					className={classes.workspace}
					px={theme.spacing.xl}
				>
					<Text size="sm">{region}</Text>
					{data?.REGION === region && <Icon name="check" />}
				</Group>
			))}
		</Stack>
	);
}
